<template>
  <div>
    <!-- empty div required for root dialog component -->
    <b-modal
      ref="modal"
      :title="$t('managers.add_new')"
      :ok-disabled="!model.user_id"
      size="sm"
      centered
    >
      <form ref="form" @submit="save">
        <fields :form="this" layout="vertical" />
      </form>
    </b-modal>
  </div>
</template>

<script>
import { FormMixin } from 'stylemix-base'
import ManagersApi from './ManagersApi'

export default {
  name: 'AddManager',

  mixins: [FormMixin],

  data() {
    return {
      model: {
        user_id: null,
      },
    }
  },

  mounted() {
    const modal = this.$refs.modal

    modal.show()

    modal.$on('close', () => {
      this.$close()
    })

    modal.$on('ok', event => {
      event.preventDefault()
      this.save()
    })

    modal.$on('cancel', () => {
      this.$close()
    })

    this.setFields([
      {
        attribute: 'user_id',
        component: 'relation-field',
        label: 'User',
        ajax: true,
        source: {
          url: 'users',
          params: {
            context: 'options',
          },
        },
      },
    ])
  },

  methods: {
    save() {
      return this.$uiBlocker(
        new ManagersApi()
          .assign(this.model.user_id)
          .then(result => {
            this.$refs.modal.hide()
            this.$close(true)
            this.$toast.success(result.message)
          })
          .catch(error => {
            if (error.status === 422) {
              this.setValidationErrors(error.data.errors)
            }
            return Promise.reject(error)
          }),
        this.$refs.modal.$refs.content,
      )
    },
  },
}
</script>
